import { render, staticRenderFns } from "./InstructionBottomSheet.vue?vue&type=template&id=578acb1a&scoped=true&lang=pug&"
import script from "./InstructionBottomSheet.vue?vue&type=script&lang=js&"
export * from "./InstructionBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./InstructionBottomSheet.vue?vue&type=style&index=0&id=578acb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578acb1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomSheet,VCard,VCardText,VChip,VIcon})
